module.exports = __webpack_public_path__ + "static/media/playIcon.e609758a.svg";